import { observer } from 'mobx-react-lite';
import React from 'react';
import { Box, Flex } from '@cad-arc';
import { Tooltip } from '../../../common/components/tooltip';
import {
    EventQueueRowData,
    ScheduledEventQueueRowData,
    UnitQueueRowData,
} from '../../../socket/stream-types';
import { EventLocationCaution } from './event-location-caution';
import { BaseQueueCell } from '../base-queue-cell';
import { getEventQueueRowDataOrScheduledEventQueueRowData } from '../../utils/get-event-queue-row-data';
import { useQueueStore } from '../../context/use-queue-store';
import { useContextMenuStateWrite } from '../../context/use-context-menu-state';
import { useOpenEventPanel } from '../../../event-panel/use-open-event-panel';

export const EventLocationCell = observer(function EventLocationCell({
    data,
}: {
    data: EventQueueRowData | UnitQueueRowData | ScheduledEventQueueRowData;
}): React.ReactElement {
    const dataToUse = getEventQueueRowDataOrScheduledEventQueueRowData(data);
    const queueStore = useQueueStore();
    const contextMenuStateWrite = useContextMenuStateWrite();
    const openEventPanel = useOpenEventPanel();
    const entityType = queueStore.workspacePanel.queue.dataEntityType;

    const clickEventLocationCaution = React.useCallback((): void => {
        if (dataToUse !== undefined) {
            openEventPanel({
                eventId: dataToUse.id,
                workspacePanelConfig: {
                    panelState: {
                        initialTab: 'CAUTIONS',
                    },
                },
                activeTab: 'LOCATION_CAUTIONS',
            });
        }
    }, [dataToUse, openEventPanel]);

    if (!dataToUse) {
        return <span />;
    }

    return (
        <BaseQueueCell
            onContextMenu={() => {
                contextMenuStateWrite(
                    entityType === 'SCHEDULED_AGENCY_EVENT'
                        ? { kind: 'SCHEDULED_EVENT', data: dataToUse }
                        : { kind: 'EVENT', entityId: dataToUse.id }
                );
            }}
        >
            <Flex align="center" justify="space-between" gap="1">
                <Tooltip overlay={dataToUse.eventLocationTip}>
                    <Box as="span" minWidth={0} overflow="hidden" textOverflow="ellipsis">
                        {dataToUse.eventLocation}
                    </Box>
                </Tooltip>
                {dataToUse.highestPriorityLocationCaution ||
                dataToUse.isNearbyLocationCautionPriority1 ? (
                    // Sizes the caution button for the queue rows (see index.css)
                    <Box as="span" className="queue-cell-button">
                        <EventLocationCaution
                            onClick={clickEventLocationCaution}
                            data={dataToUse}
                            className="queue-cell-icon"
                        />
                    </Box>
                ) : null}
            </Flex>
        </BaseQueueCell>
    );
});
